<template>
  <div class="pay-invoice-succsss-page">
    <invoice-fixed-header :show-page-title="false"></invoice-fixed-header>

    <div class="center-content">
      <img
        src="../../assets/imgs/invoice-manage/icon-success.png"
        class="pay-success-img"
      />
      <div class="pay-success-title">{{ isApply ? '申请成功' : '支付成功' }}</div>
      <div class="pay-success-tips">
        开具电子发票需三至五个工作日，请留意公众号消息通知开票结果。
        <!-- 开具电子发票需三至五个工作日，纸质发票需根据物流信息而定， -->
      </div>
      <!-- <div class="pay-success-tips">请留意公众号消息通知开票结果。</div> -->
      <div class="pay-continue-handles">
        <div class="handle-btn continue-new-invoice" @click="goInvoiceManage('newInvoice')">继续开票</div>
        <div class="handle-btn show-invoice-detail" @click="goInvoiceManage('historyInvoices')">查看发票</div>
      </div>
    </div>
  </div>
</template>

<script>
import invoiceFixedHeader from './components/invoice-fixed-header';

export default {
  name: 'pay-invoice-succsss-page',
  components: {
    invoiceFixedHeader,
  },
  data() {
    return {
      isApply: false, // 是否为申请
    };
  },
  created() {
    this.isApply = this.$route.query.is_apply || false;
  },
  methods: {
    goInvoiceManage(tab) {
      this.$router.replace({
        name: 'invoiceManage',
        query: {
          tab,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.pay-invoice-succsss-page {
  display: flex;
  .center-content {
    margin: 20px auto 0 auto;
    width: 800px;
    height: 433px;
    background: #ffffff;
    box-shadow: 0px 8px 16px -4px rgba(34, 38, 46, 0.08);
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .pay-success-img {
      width: 157px;
      height: 101px;
      margin-top: 60px;
    }
    .pay-success-title {
      margin-top: 24px;
      font-size: 20px;
      font-weight: 500;
      color: #2f333d;
      line-height: 24px;
      margin-bottom: 12px;
    }
    .pay-success-tips {
      font-size: 18px;
      font-weight: 400;
      color: #91999f;
      line-height: 30px;
    }
    .pay-continue-handles {
      margin-top: 24px;
      display: flex;
      align-items: center;
      .handle-btn {
        width: 176px;
        height: 48px;
        border-radius: 4px;
        font-size: 18px;
        font-weight: 400;
        line-height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &:hover {
          opacity: 0.9;
        }
        &.continue-new-invoice {
          color: #599fff;
          border: 1px solid #599fff;
        }
        &.show-invoice-detail {
          background-color: #599FFF;
          color: white;
          margin-left: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoice-manage/PayInvoiceSuccess.vue